export const RESET_RESHIPMENT_FLOW = 'RESET_RESHIPMENT_FLOW'
export const FETCH_RESHIPMENT_SUMMARY_PENDING = 'FETCH_RESHIPMENT_SUMMARY_PENDING'
export const FETCH_RESHIPMENT_SUMMARY_FULFILLED = 'FETCH_RESHIPMENT_SUMMARY_FULFILLED'
export const FETCH_RESHIPMENT_SUMMARY_REJECTED = 'FETCH_RESHIPMENT_SUMMARY_REJECTED'

export const FETCH_SAVED_RESHIPMENT_ITEMS_PENDING = 'FETCH_SAVED_RESHIPMENT_ITEMS_PENDING'
export const FETCH_SAVED_RESHIPMENT_ITEMS_FULFILLED = 'FETCH_SAVED_RESHIPMENT_ITEMS_FULFILLED'
export const FETCH_SAVED_RESHIPMENT_ITEMS_REJECTED = 'FETCH_SAVED_RESHIPMENT_ITEMS_REJECTED'

export const FETCH_NON_SECURE_MATERIALS_PENDING = 'FETCH_NON_SECURE_MATERIALS_PENDING'
export const FETCH_NON_SECURE_MATERIALS_FULFILLED = 'FETCH_NON_SECURE_MATERIALS_FULFILLED'
export const FETCH_NON_SECURE_MATERIALS_REJECTED = 'FETCH_NON_SECURE_MATERIALS_REJECTED'

export const RESHIPMENT_SAVE_PENDING = 'RESHIPMENT_SAVE_PENDING'
export const RESHIPMENT_SAVE_FULFILLED = 'RESHIPMENT_SAVE_FULFILLED'
export const RESHIPMENT_SAVE_REJECTED = 'RESHIPMENT_SAVE_REJECTED'

export const RESHIPMENT_SUBMIT_PENDING = 'RESHIPMENT_SUBMIT_PENDING'
export const RESHIPMENT_SUBMIT_FULFILLED = 'RESHIPMENT_SUBMIT_FULFILLED'
export const RESHIPMENT_SUBMIT_REJECTED = 'RESHIPMENT_SUBMIT_REJECTED'

export const FETCH_APPROVED_RESHIPMENT_MATERIALS_PENDING =
  'FETCH_APPROVED_RESHIPMENT_MATERIALS_PENDING'
export const FETCH_APPROVED_RESHIPMENT_MATERIALS_FULFILLED =
  'FETCH_APPROVED_RESHIPMENT_MATERIALS_FULFILLED'
export const FETCH_APPROVED_RESHIPMENT_MATERIALS_REJECTED =
  'FETCH_APPROVED_RESHIPMENT_MATERIALS_REJECTED'

export const ADD_NEW_MATERIAL = 'ADD_NEW_MATERIAL'
export const SELECT_NEW_MATERIAL = 'SELECT_NEW_MATERIAL'
export const CANCEL_ADD_NEW_MATERIAL = 'CANCEL_ADD_NEW_MATERIAL'
export const FINISHED_ADDING_NEW_MATERIAL = 'FINISHED_ADDING_NEW_MATERIAL'

export const RESHIPMENT_FORM_NAME = 'reshipmentForm'
export const RESHIPMENT_QTY_FIELD = 'reshipQuantity'
export const RESHIPMENT_NEW_MATERIAL = 'reshipmentNewMaterial'

export const NEW_ITEM = 'newItem'

export const PENDING_SUBMISSION = 'PENDING_SUBMISSION'
export const APPROVAL_PENDING = 'APPROVAL_PENDING'
export const PENDING_RESUBMISSION = 'PENDING_RESUBMISSION'
export const NEED_INFO = 'REQUIRES_INFO'
export const REJECTED = 'REJECTED'

export const STATUS_DESCRIPTIONS = {
  [APPROVAL_PENDING]: 'Pending Approval',
  [PENDING_RESUBMISSION]: 'Pending Resubmission',
  [NEED_INFO]: 'Needs Info',
  [REJECTED]: 'Denied',
}
